import { render, staticRenderFns } from "./PromoActionTagCreateDialog.vue?vue&type=template&id=6cf44f7a&scoped=true&"
import script from "./PromoActionTagCreateDialog.vue?vue&type=script&lang=js&"
export * from "./PromoActionTagCreateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf44f7a",
  null
  
)

export default component.exports